import React, { FC } from 'react'
import styled from 'styled-components'

interface Prop {
  color?: 'white' | 'black'
  descr?: string
}

/*
 * Module scope, not inside the component: styled-components regenerated these
 * classes on every render otherwise. The desktop/mobile margin split is a
 * media query now instead of a closure over useScreenClass, so the heading no
 * longer has to wait for a screen-class measurement to size itself.
 */
const Title = styled.h2<{ color: string }>`
  font-size: var(--fs-display-md);
  text-align: center;
  margin: 0 0 2rem;
  color: ${(props) => (props.color === 'white' ? 'white' : 'black')};
  /* Long words (URLs, compound names) used to push these past the screen. */
  overflow-wrap: break-word;

  @media (max-width: 767px) {
    margin: 0 0 1.5rem;
  }
`

const Description = styled.p<{ color: string }>`
  text-align: center;
  color: ${(props) => (props.color === 'white' ? 'white' : 'black')};
  margin: 0 auto;
  max-width: 60ch;
  /* Kept the old horizontal breathing room, as padding so it survives the
     centring above. */
  padding: 0 1.25rem;
`

const SectionTitle: FC<Prop> = ({ children, color = 'white', descr }) => (
  <>
    <Title color={color}>{children}</Title>
    {descr && <Description color={color}>{descr}</Description>}
  </>
)

export default SectionTitle
